export default "__VITE_ASSET__CyN5kcTE__"